import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { rejectInvitation, acceptInvitation, fetchUserChats } from 'modules/chats';
import { joinThemeTable } from 'modules/think-seeds/actions';
import Invitations from '../components/Invitations';

function mapStateToProps(state) {
  return {
    invitations: state.chats.invitations,
    literals: state.i18n.literals.invitations || {},
    app: state.app,
    user: state.session.user,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    rejectInvitation: bindActionCreators(rejectInvitation, dispatch),
    acceptInvitation: bindActionCreators(acceptInvitation, dispatch),
    joinThemeTable: bindActionCreators(joinThemeTable, dispatch),
    getChats: bindActionCreators(fetchUserChats, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Invitations));



// WEBPACK FOOTER //
// ./src/routes/Invitations/container/index.js